// extracted by mini-css-extract-plugin
module.exports = {"list":"specs-list_list__BQWu8","item":"specs-list_item__IIT9N","upperCase":"specs-list_upperCase__62SjC","brandNewVehicleItem":"specs-list_brandNewVehicleItem__jRSMb"};